import { type FC } from 'react'
import { twMerge } from 'tailwind-merge'
import { type SvgComponent, type DefaultProps } from '../../types'

export type ExclamationCircleProps = DefaultProps & SvgComponent

export const SvgExclamationCircle: FC<ExclamationCircleProps> = ({
  width = 16,
  height = 16,
  fill = 'none',
  testId,
  id,
  ariaLabel,
  className,
}) => {
  const finalClasses = twMerge(className)

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      {...(testId ? { 'data-testid': testId } : {})}
      {...(id ? { id } : {})}
      {...(ariaLabel ? { 'aria-label': ariaLabel } : {})}
      className={finalClasses}
    >
      <g clipPath="url(#clip0_5_3056)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15 8C15 9.85652 14.2625 11.637 12.9497 12.9497C11.637 14.2625 9.85652 15 8 15C6.14348 15 4.36301 14.2625 3.05025 12.9497C1.7375 11.637 1 9.85652 1 8C1 6.14348 1.7375 4.36301 3.05025 3.05025C4.36301 1.7375 6.14348 1 8 1C9.85652 1 11.637 1.7375 12.9497 3.05025C14.2625 4.36301 15 6.14348 15 8ZM8.875 11.5C8.875 11.7321 8.78281 11.9546 8.61872 12.1187C8.45462 12.2828 8.23206 12.375 8 12.375C7.76794 12.375 7.54538 12.2828 7.38128 12.1187C7.21719 11.9546 7.125 11.7321 7.125 11.5C7.125 11.2679 7.21719 11.0454 7.38128 10.8813C7.54538 10.7172 7.76794 10.625 8 10.625C8.23206 10.625 8.45462 10.7172 8.61872 10.8813C8.78281 11.0454 8.875 11.2679 8.875 11.5ZM8 3.625C7.76794 3.625 7.54538 3.71719 7.38128 3.88128C7.21719 4.04538 7.125 4.26794 7.125 4.5V8C7.125 8.23206 7.21719 8.45462 7.38128 8.61872C7.54538 8.78281 7.76794 8.875 8 8.875C8.23206 8.875 8.45462 8.78281 8.61872 8.61872C8.78281 8.45462 8.875 8.23206 8.875 8V4.5C8.875 4.26794 8.78281 4.04538 8.61872 3.88128C8.45462 3.71719 8.23206 3.625 8 3.625Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_5_3056">
          <rect width="14" height="14" transform="translate(1 1)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default SvgExclamationCircle
